<template>
  <div class="form__group">
    <component :field="field" :is="'checkout-field-' + field.handler">
    </component>
    <div class="form__breaker"></div>
    <component
      v-for="currentField in currentFields"
      :key="currentField.name"
      :field="currentField"
      :is="'checkout-field-' + currentField.type"
    >
    </component>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-conditional",
  computed: {
    currentFields: function() {
      return this.field.fields
        .filter(field => field.name === this.field.value)
        .filter(field => !field.disabled);
    }
  }
};
</script>
